import { ApiBase } from "./ApiBase";

export interface NotificationHighlight {
  label: string;
  value: string;
  emphasise: boolean;
}

export interface NotificationCta {
  label: string;
  url: string;
}

export interface Notification {
  id: string;
  headline: string;
  category: string;
  context: string | null;
  highlights: NotificationHighlight[];
  details: string[];
  meta: Record<string, string> | null;
  cta: NotificationCta | null;
  createdAt: string;
  readAt: string | null;
  isRead: boolean;
}

export interface GetNotificationsResponse {
  notifications: Notification[];
  totalUnreadCount: number;
  nextCursor: number | null;
}

class NotificationsApi extends ApiBase {
  getNotifications(
    cursor: number,
    limit: number,
  ): Promise<GetNotificationsResponse> {
    return this.get<GetNotificationsResponse>("/notifications", {
      params: {
        cursor,
        limit,
      },
    });
  }

  markAsRead(ids: string[]): Promise<void> {
    return this.post("/notifications/mark-as-read", {
      ids,
    });
  }

  deleteNotification(id: string): Promise<void> {
    return this.delete<void>(`/notifications/${id}`);
  }

  addPushSubscription(subscription: {
    endpoint: string;
    expirationTime: number | null;
    keys: Record<string, string>;
  }): Promise<void> {
    return this.post("/notifications/push-subscription", {
      endpoint: subscription.endpoint,
      expirationTime: subscription.expirationTime,
      keys: subscription.keys,
    });
  }

  removePushSubscription(endpoint: string): Promise<void> {
    return this.delete("/notifications/push-subscription", {
      data: { endpoint },
    });
  }

  getVapidPublicKey(): Promise<string> {
    return this.get("/notifications/vapid-public-key");
  }
}

export const notificationsApi = new NotificationsApi();
